<template>
    <div class="preloader">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" fill="none" :stroke="color" stroke-width="10" r="40" stroke-dasharray="215"></circle>
        </svg>
    </div>
</template>

<script>
export default {
    props:{
        color:{
            type: String,
            default: '#009579',
        }
    }
}
</script>